export default __webpack_public_path__ + "static/media/main-category-hair-beauty.183ae881.jpg";